import { Injectable } from '@angular/core';
import { TokenPair } from '../../dtos/TokenPair';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  public get STORAGE_TOKEN_KEY() {
    return "APP_WORKIA_TOKEN_STORAGE";
  }

  decodeToken (token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  isTokenExpired(token: string){
    if (!token)
      return true;

    const payload = this.decodeToken(token);
    if(!payload.exp)
      return true;
    const expDate = new Date(0);
    expDate.setUTCSeconds(payload.exp);
    
    // Add 30 second buffer before actual expiration
    const bufferTime = 30 * 1000; // 30 seconds in milliseconds
    return expDate.getTime() - bufferTime < new Date().getTime();
  }
  
  getToken(): TokenPair | undefined {
    const tokens = localStorage.getItem(this.STORAGE_TOKEN_KEY);
    if (!tokens) {
      

      return undefined;
    }

    return JSON.parse(tokens);
  }
  
  saveToken(tokenPair: TokenPair | null | undefined) {
    if (!tokenPair)
      return;
    return localStorage.setItem(this.STORAGE_TOKEN_KEY, JSON.stringify(tokenPair));
  }

  clearToken(){
    localStorage.removeItem(this.STORAGE_TOKEN_KEY);
  }
}
